import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { HeartOff, Home } from "lucide-react";

export default function UnsubscribeCitizen() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [reason, setReason] = useState("");
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/citizens/preferences/${token}`).then(({ data }) => setData(data)).catch(() => setData({ error: true }));
  }, [token]);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/citizens/unsubscribe/${token}`, { reason });
      setDone(true);
    } catch { toast.error("Error"); }
    setSaving(false);
  };

  if (!data) return <PublicLayout><div className="py-20 text-center text-muted-foreground">Carregant…</div></PublicLayout>;

  return (
    <PublicLayout>
      <div className="max-w-md mx-auto px-6 py-20">
        <Card className="rounded-3xl border-2 shadow-xl">
          <CardContent className="p-8">
            {done ? (
              <div className="text-center" data-testid="unsub-done">
                <div className="w-16 h-16 mx-auto rounded-2xl bg-secondary text-muted-foreground flex items-center justify-center mb-4">
                  <HeartOff className="w-8 h-8" aria-hidden="true" />
                </div>
                <h1 className="font-heading font-bold text-2xl">Ja no rebràs més correus</h1>
                <p className="text-muted-foreground mt-3">Sentim veure't marxar. Podràs tornar-te a subscriure quan vulguis.</p>
                <Button asChild className="mt-6 rounded-full" data-testid="unsub-home">
                  <Link to="/"><Home className="w-4 h-4 mr-2" aria-hidden="true" /> Tornar a l'inici</Link>
                </Button>
              </div>
            ) : data.error ? (
              <div className="text-center text-muted-foreground">Enllaç invàlid.</div>
            ) : (
              <>
                <div className="text-center mb-6">
                  <div className="w-14 h-14 mx-auto rounded-2xl bg-destructive/10 text-destructive flex items-center justify-center mb-4">
                    <HeartOff className="w-6 h-6" aria-hidden="true" />
                  </div>
                  <h1 className="font-heading font-bold text-2xl">Donar-me de baixa</h1>
                  <p className="text-sm text-muted-foreground mt-2">Ja no rebràs comunicacions a <strong>{data.email}</strong>.</p>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="text-sm font-medium">Ens pots dir per què? (opcional)</label>
                    <Textarea value={reason} onChange={(e) => setReason(e.target.value)} className="mt-2 rounded-xl" placeholder="Massa correus, no és el que esperava, etc." data-testid="unsub-reason" />
                  </div>
                  <Button onClick={submit} disabled={saving} className="w-full rounded-full h-12" variant="destructive" data-testid="unsub-btn">
                    {saving ? "Enviant…" : "Confirmar baixa"}
                  </Button>
                  <Button asChild variant="outline" className="w-full rounded-full" data-testid="unsub-cancel">
                    <Link to={`/preferencies/${token}`}>O gestiona les meves preferències</Link>
                  </Button>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </PublicLayout>
  );
}
